import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EMPTY } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { I18nService } from '../i18n/i18n.service';

import { TranslationKeyMap } from './auth.i18n';
import { AuthService } from './auth.service';

@Component({
    selector: 'cmps-auth-logout',
    templateUrl: './logout.auth.component.html',
})
export class LogoutAuthComponent implements OnInit {
    i18n = TranslationKeyMap;

    constructor(
        private readonly _router: Router,
        private readonly _translateService: TranslateService,
        private readonly _authService: AuthService,
        private readonly _i18nService: I18nService,
        @Inject(CMPS_APP_CONFIG) public appConfig: AppConfig,
    ) {}

    ngOnInit(): void {
        this._authService
            .logout()
            .pipe(
                switchMap(() => {
                    const locale = this._i18nService.locale;
                    const lang = this._i18nService.languages.find(
                        (e) => e.initial === locale,
                    );
                    return (
                        (
                            !lang || lang.id == null
                                ? EMPTY
                                : this._translateService.use(lang.id.toString())
                        )
                            // eslint-disable-next-line @typescript-eslint/no-misused-promises, @typescript-eslint/promise-function-async
                            .pipe(
                                // eslint-disable-next-line @typescript-eslint/no-misused-promises, @typescript-eslint/promise-function-async
                                finalize(() =>
                                    this._router.navigate(['login']),
                                ),
                            )
                    );
                }),
            )
            .subscribe();
    }
}
